import { render, staticRenderFns } from "./nurseOrder.vue?vue&type=template&id=21f7b648&scoped=true&"
import script from "./nurseOrder.vue?vue&type=script&lang=js&"
export * from "./nurseOrder.vue?vue&type=script&lang=js&"
import style0 from "./nurseOrder.vue?vue&type=style&index=0&id=21f7b648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f7b648",
  null
  
)

export default component.exports